module.exports = __webpack_public_path__ + "static/RR_Back_Small-ea52e7a031f2793fd046b7ddd2e7a075.png";